module.exports = __webpack_public_path__ + "static/media/az.6b17b6d6.svg";